module.exports = __webpack_public_path__ + "img/3-2.d3c0353c.png";